const PermissionTypes = {
  AANBOD_BEWERKEN: 'AANBOD_BEWERKEN',
  AANBOD_MODEREREN: 'AANBOD_MODEREREN',
  AANBOD_VERWIJDEREN: 'AANBOD_VERWIJDEREN',
  AANBOD_HISTORIEK: 'AANBOD_HISTORIEK',
  ORGANISATIES_BEWERKEN: 'ORGANISATIES_BEWERKEN',
  ORGANISATIES_BEHEREN: 'ORGANISATIES_BEHEREN',
  GEBRUIKERS_BEHEREN: 'GEBRUIKERS_BEHEREN',
  LABELS_BEHEREN: 'LABELS_BEHEREN',
  VOORZIENINGEN_BEWERKEN: 'VOORZIENINGEN_BEWERKEN',
  PRODUCTIES_AANMAKEN: 'PRODUCTIES_AANMAKEN',
  FILMS_AANMAKEN: 'FILMS_AANMAKEN',
  MEDIA_UPLOADEN: 'MEDIA_UPLOADEN',
} as const;

// Destructure to exclude MEDIA_UPLOADEN
const { MEDIA_UPLOADEN, ...CorePermissionTypes } = PermissionTypes;

export type PermissionType =
  (typeof PermissionTypes)[keyof typeof PermissionTypes];

export { CorePermissionTypes, PermissionTypes };
